import View from '../../../Core/View.js';
import raf from 'raf';

class BoatHighlights extends View {

	/**
	 *
	 */
	static CLASS_MOVING_STATE = 'boat-highlights__boat--moving';
	static CLASS_BOTTOM_STATE = 'boat-highlights__boat--bottom';
	static CLASS_ROTATED_STATE = 'boat-highlights__boat--rotation';
	static CLASS_BLOCK_SHOW_STATE = 'boat-highlights__block--show';

	/**
	 *
	 */
	initialize() {
		this.$boat = this.$el.find('.boat-highlights__boat');
		this.$water = this.$el.find('.boat-highlights__water');
		this.$highlights = this.$el.find('.boat-highlights__block');

		this.verticalMiddleLine = window.innerHeight / 2;

		this.updateBoat();
	}

	/**
	 *
	 * @param {jQuery} $boat
	 */
	updateBoat() {
		this.showHighlights();

		if (this.hasWaterTopPassedMiddle()) {
			this.startMoving();

		} else {
			this.stopMoving();
			this.$boat
				.removeClass(BoatHighlights.CLASS_ROTATED_STATE);
		}
		if (this.hasWaterBottomPassedMiddle()) {
			this.$boat
				.addClass(BoatHighlights.CLASS_ROTATED_STATE);
			this.boatAtBottomPosition();
		}

		raf(this.updateBoat.bind(this));
	}

	/**
	 *
	 * @returns {Array}
	 */
	getHighlights() {
		const highlightPositionsArray = [];
		this.$highlights.each(function(index, el) {
			var highlightBox = el.getBoundingClientRect();
			highlightPositionsArray.push(highlightBox.top);
		});
		return highlightPositionsArray;
	}

	/**
	 *
	 * @returns {ClientRect}
	 */
	getBoatPosition() {
		var boat = this.$boat.get(0);
		var viewPortBoat = boat.getBoundingClientRect();

		return viewPortBoat;
	}

	/**
	 *
	 */
	showHighlights() {
		var highlightPositions = this.getHighlights();
		var boatPosition = this.getBoatPosition();

		for (var i = 0; i < highlightPositions.length; i++) {
			if (boatPosition.top >= highlightPositions[i]) {
				this.$highlights.eq(i)
					.addClass(BoatHighlights.CLASS_BLOCK_SHOW_STATE);
			}
			//do nothing
		}
	}

	/**
	 *
	 * @returns {boolean}
	 */
	hasWaterTopPassedMiddle() {
		var water = this.$water.get(0);
		this.viewPortWater = water.getBoundingClientRect();
		var distanceFromTopToMid = this.viewPortWater.top - this.verticalMiddleLine;

		return distanceFromTopToMid <= 0;
	}

	/**
	 *
	 * @returns {boolean}
	 */
	hasWaterBottomPassedMiddle() {
		var water = this.$water.get(0);
		var viewPortWater = water.getBoundingClientRect();
		var distanceFromBottomToMid = viewPortWater.bottom - this.verticalMiddleLine;
		var boat = this.getBoatSize();
		return distanceFromBottomToMid - boat <= 0;
	}

	/**
	 *
	 * @returns {number}
	 */
	getBoatSize() {
		var viewPortBoat = this.getBoatPosition();

		return viewPortBoat.bottom - viewPortBoat.top;
	}

	/**
	 *
	 * @param {jQuery} $boat
	 */
	startMoving() {
		this.$boat
			.removeClass(BoatHighlights.CLASS_BOTTOM_STATE)
			.addClass(BoatHighlights.CLASS_MOVING_STATE);
	}

	/**
	 *
	 * @param {jQuery} $boat
	 */
	stopMoving() {
		this.$boat
			.removeClass(BoatHighlights.CLASS_MOVING_STATE);
	}

	/**
	 *
	 */
	boatAtBottomPosition() {
		this.$boat
			.addClass(BoatHighlights.CLASS_BOTTOM_STATE)
			.removeClass(BoatHighlights.CLASS_MOVING_STATE);
		this.classState = true;
	}
}

export default BoatHighlights;


// WEBPACK FOOTER //
// ./js/Views/Modules/BoatHighlights/BoatHighlights.js